import { render, staticRenderFns } from "./ModalSelecionarTelefoneWhatsApp.vue?vue&type=template&id=31ba90e0&scoped=true"
import script from "./ModalSelecionarTelefoneWhatsApp.vue?vue&type=script&lang=ts"
export * from "./ModalSelecionarTelefoneWhatsApp.vue?vue&type=script&lang=ts"
import style0 from "./ModalSelecionarTelefoneWhatsApp.vue?vue&type=style&index=0&id=31ba90e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba90e0",
  null
  
)

export default component.exports